
<mat-drawer-container class="document-wrapper">

  <!-- MAIN CONTENT -->
  <mat-drawer-content class="page-scroll" [ngStyle]="{'height': scrHeight}" style="overflow: auto;">
    <div id="global-loader" class="global-loader" *ngIf="isLoading && !showActivityStream">
      <div class="spinner"></div>
    </div>
    <div class="container m-1">
      <div class="stat-cards-container" [@collapseExpand]="showStatCards ? 'expanded' : 'collapsed'" *ngIf="showStatCards">
        <div class="row g-3">
        @for(proj of projectCardDetails; track proj.titleValue){
        <div class="col-12 col-sm-6 col-lg-4">
          <mat-card class="stat-card" (click)="filterByStatus(proj.titleValue)" style="cursor: pointer;">
            <div class="card-content">
              <div>
                <div class="card-title">{{ proj.title }} </div>
                <div class="card-number" [ngClass]="{ 'text-danger' : proj.title == 'Overdue' }">{{ proj.value }}</div>
                </div>
                <mat-icon class="card-icon {{ proj.color }}">{{ proj.icon }}</mat-icon>
                </div>
                </mat-card>
                </div>
                }
                </div>
      </div>

      <div class="search-row d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2">
        <div class="header2 flex-column flex-md-row gap-2">
          <div class="search-container bg-1 flex-grow-1">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text" class="search-box bg-1" placeholder="Search projects by name, ID, or collection"
              (input)="applySearch($event)">
          </div>

          <!-- Date Filter Dropdown -->
          <select class="form-select date-filter-select flex-shrink-0" [(ngModel)]="selectedDateFilter"
            (change)="applyDateFilter(selectedDateFilter)">
            @for(option of filterDateOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
          <button class="btn pill-btn flex-shrink-0" (click)="reloadPage()" title="Refresh">
            <mat-icon>refresh</mat-icon>
          </button>

          <!-- Filter Button -->
          <button class="btn pill-btn flex-shrink-0" (click)="filterDrawer.open()" title="Open Filters">
            <mat-icon>filter_alt</mat-icon>
            <span>Filters</span>
          </button>

          <!-- Sort Button -->
          <button class="btn pill-btn flex-shrink-0" type="button" [matMenuTriggerFor]="sortMenu" title="Open Sort Menu">
            <mat-icon>sort</mat-icon>
            <span>Sort</span>
          </button>

          <!-- Toggle Statistics Button -->
          <button class="btn toggle-stats-btn flex-shrink-0" (click)="showStatCards = !showStatCards" 
                  title="{{ showStatCards ? 'Hide' : 'Show' }} statistics">
            <mat-icon>{{ showStatCards ? 'visibility_off' : 'visibility' }}</mat-icon>
            <span>{{ showStatCards ? 'Hide' : 'Show' }} Stats</span>
          </button>

          <mat-menu #sortMenu="matMenu">

            @for(col of sortableColumns; track col.id) {
            <button mat-menu-item (click)="toggleSort(col.id)">
              <mat-icon>
                {{ getSortIcon(col.id) }}
              </mat-icon>
              {{ col.label }}
            </button>
            }

          </mat-menu>

        </div>
      </div>
      <div class="project-table-wrapper mt-3">
        <div *ngIf="dataSource.data.length === 0" class="no-records-container mt-3">
          <div class="no-records-message">
            <mat-icon class="no-records-icon">folder_off</mat-icon>
            <h3>No Records Found</h3>
            <p>There are no projects to display.</p>
          </div>
        </div>
        <div class="table-responsive">
        <table *ngIf="dataSource.data.length > 0" mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
          class="project-table table">


          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
                @if (row.departments && row.departments.length > 0) {
                
              <button mat-icon-button (click)="expandedElement = expandedElement === row ? null : row"
                [ngClass]="{ 'expanded': expandedElement === row }" class="expand-btn">
                <mat-icon class="expand-icon" [fontIcon]="expandedElement === row ? 'expand_more' : 'chevron_right'">
                </mat-icon>
              </button>
              } @else {
              <span style="width: 24px; display: inline-block;"></span>
              }
            </td>
          </ng-container>

        

          <!-- Project ID -->
          <ng-container matColumnDef="project_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>PROJECT NAME</th>
            <td mat-cell *matCellDef="let row" class="project-id">
              <div class="project-name-container">
                <a class="project-id-link" (click)="row.status === 'Draft' ? editProject(row) : goToProjectDetails(row)">{{
                  row.project_name }}</a>
                <div class="inline-actions">
                  <!-- Draft status: Show Edit and Delete -->
                  <ng-container *ngIf="row.status === 'Draft'">
                    <button mat-icon-button matTooltip="Edit" (click)="editProject(row)" class="inline-action-btn edit-btn">
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Delete" (click)="deleteProject(row)" class="inline-action-btn delete-btn">
                      <mat-icon class="material-icons-outlined">delete</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Department -->
          <ng-container matColumnDef="departments">
            <th mat-header-cell *matHeaderCellDef class="d-none d-md-table-cell">DEPARTMENT NAME</th>
            <td mat-cell *matCellDef="let row" class="d-none d-md-table-cell">
              <div style="display: flex; flex-direction: column; gap: 2px; align-items: flex-start;">
                <!-- <div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;"> -->
                @if (row.departments && row.departments.length > 0) {
                @for (dept of row.departments.slice(0,2); track dept.department_id) {
                    {{ dept.department_name }}
                  }
                  
                  @if (row.departments.length > 2) {
                  <span class="department-more">
                    +{{ row.departments.length - 2 }} more
                  </span>
                  }
                } @else {
                  <span style="color: #9ca3af;">No departments</span>
                  }
                  @if (row.departments && row.departments.length > 0) {
                  <div class="department-count-badge">
                    <mat-icon class="badge-icon" fontIcon="check_circle_outline"></mat-icon>
                    {{ getCompletedDepartmentsCount(row).completed }}/{{ getCompletedDepartmentsCount(row).total }} departments
                  </div>
                  }
              </div>
            </td>
            </ng-container>

          
          <ng-container matColumnDef="overallStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>OVERALL STATUS</th>
            <td mat-cell *matCellDef="let row"
              >
              <!-- <span class="status-chip" [ngClass]="{
                                            'status-progress': getOverallStatus(row) === 'In Progress' || getOverallStatus(row) === 'SUBMITTED',
        'status-pending': getOverallStatus(row) === 'Pending Review',
        'status-completed': getOverallStatus(row) === 'Completed',
        'status-draft': getOverallStatus(row) === 'Draft',
        'status-overdue': getOverallStatus(row) === 'Overdue'
      }">
                {{ getOverallStatus(row) }}
              </span> -->
            <span class="status-chip" [ngClass]="{ 'status-progress' : row.status === 'Submitted' || row.status === 'In progress' || row.status === 'In Progress', 'status-pending': row.status === 'Pending Review', 'status-pending-rre-review': row.status === 'Pending RRE Review', 'status-pending-review': row.status === 'Pending RAES Review', 'status-completed': row.status === 'Completed', 'status-draft': row.status === 'Draft', 'status-overdue': row.status === 'Overdue' }">
              <mat-icon class="status-icon" *ngIf="row.status === 'Draft'">edit</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'Submitted'">schedule</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'In progress' || row.status === 'In Progress'">trending_up</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'Pending Review'">pending_actions</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'Pending RRE Review'">person</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'Pending RAES Review'">fact_check</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'Completed'">check_circle</mat-icon>
              <mat-icon class="status-icon" *ngIf="row.status === 'Overdue'">error</mat-icon>
              {{ row.status }}</span>
            </td>
          </ng-container>
          <!-- project_created_at -->
          <ng-container matColumnDef="project_created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="d-none d-lg-table-cell">CREATED DATE</th>
            <td mat-cell *matCellDef="let row" class="date-cell d-none d-lg-table-cell">{{ row.project_created_at | date:'MMM d, yyyy hh:mm a' }}</td>
          </ng-container>
          <!-- due_date -->
          <ng-container matColumnDef="due_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="d-none d-lg-table-cell">DUE DATE</th>
            <td mat-cell *matCellDef="let row" class="date-cell d-none d-lg-table-cell">{{ row.due_date | date:'mediumDate':'UTC' }}</td>
          </ng-container>

          <!-- Status -->
          <!-- <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        <span class="status-chip"
          [ngClass]="{ 'status-progress' : row.status === 'In Progress', 'status-pending': row.status === 'Pending Review', 'status-completed': row.status === 'Completed', 'status-draft': row.status === 'Draft',  'status-overdue': row.status === 'OVERDUE' }">
          {{ row.status }}
        </span>
      </td>
    </ng-container> -->

          <!-- Due Date -->
          <!-- <ng-container matColumnDef="dueDate">
      <th mat-header-cell *matHeaderCellDef>Due Date</th>
      <td mat-cell *matCellDef="let row">{{ row.dueDate | date }}</td>
    </ng-container> -->

          <!-- Collection -->
          <ng-container matColumnDef="collection_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="d-none d-md-table-cell">COLLECTION</th>
            <td mat-cell *matCellDef="let row" class="d-none d-md-table-cell">{{ row.collection_name }}</td>
            </ng-container>

          <!-- Sub Collection -->
          <ng-container matColumnDef="sub_collection_name">
            <th mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell">SUB-COLLECTION</th>
            <td mat-cell *matCellDef="let row" class="d-none d-lg-table-cell">
              @if (row.sub_collection_name && row.sub_collection_name.length > 0) {
                <span>{{ row.sub_collection_name.join(', ') }}</span>
              } @else {
                <span style="color: #9ca3af;">No sub-collections</span>
              }
            </td>
            </ng-container>

            <!-- Contact person -->
            <ng-container matColumnDef="contact_person">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="d-none d-lg-table-cell">CONTACT PERSON</th>
              <td mat-cell *matCellDef="let row" class="d-none d-lg-table-cell">{{ row.contact_person }}</td>
            </ng-container>
          <!-- Activity -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>ACTIVITY</th>
            <td mat-cell *matCellDef="let row">
              <button class="activity-trigger-btn" (click)="openActivityStream('main', row); $event.stopPropagation()" matTooltip="View activity stream">
                <span class="activity-pill">
                  <mat-icon class="material-icons-outlined">visibility</mat-icon>
                  {{ row.activity }}
                </span>
              </button>
              <button *ngIf="row.status !== 'Draft'" class="activity-trigger-btn" (click)="confirmCopyDetails(row); $event.stopPropagation()" matTooltip="Copy details">
                <span class="activity-pill">
                  <mat-icon class="material-icons-outlined">content_copy</mat-icon>
                </span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
              <div class="dept-expanded-wrapper" *ngIf="expandedElement === row">
                <div class="dept-tasks-container">
                  <div class="dept-header">
                    <div></div>
                    <div>Department Name</div>
                    <div>Assigned To</div>
                    <div></div>
                    <div style="margin-left: 12px;">Status</div>
                    <div>Last updated Date</div>
                    <div></div>
                    <div>Last updated By</div>
                    <div>Activity</div>
                  </div>

                  @for (dept of row.departments; track dept.department_id) {
                  <div class="dept-row">
                    <div></div>
                    <div class="dept-name">
                      <a href="javascript:void(0)" (click)="goToDepartmentDetails(dept, row)" class="dept-link">{{ dept.department_name }}</a>
                    </div>
                    <div class="dept-name">
                      {{ dept.assigned_person_name || 'Unassigned' }}
                    </div>
                    <div></div>

                    <div class="dept-status">
                      <span class="status-chip"
                        [ngClass]="{ 
                          'status-progress' : dept.sub_task_status === 'In Progress' || dept.sub_task_status === 'In progress' || dept.sub_task_status === 'in progress' || dept.sub_task_status === 'Submitted' || dept.sub_task_status === 'Assigned', 
                          'status-pending': dept.sub_task_status === 'Pending Review' || dept.sub_task_status === 'Pending review',
                          'status-pending-rre-review': dept.sub_task_status === 'Pending RRE Review',
                          'status-pending-review': dept.sub_task_status === 'Pending RAES Review',
                          'status-completed': dept.sub_task_status === 'Completed', 
                          'status-draft': dept.sub_task_status === 'Draft' || row.status === 'Draft', 
                          'status-overdue': dept.sub_task_status === 'Overdue',
                          'status-unassigned': dept.sub_task_status === 'Unassigned'
                        }">
                        {{ dept.sub_task_status || row.status }}
                      </span>
                    </div>
                    <div class="dept-name">
                      {{ (dept.sub_task_updated_at | date:'MMM d, yyyy h:mm a') || '--' }}
                    </div>
                    <div></div>
                    <div class="dept-name">
                      {{ dept.sub_task_updated_by || '--' }}
                      </div>
                      <div class="dept-activity">
                        <button class="activity-trigger-btn" (click)="openActivityStream('subtask', row, dept)" matTooltip="View activity stream">
                          <span class="activity-pill dept-activity-pill">
                            <mat-icon class="material-icons-outlined">visibility</mat-icon>
                          </span>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </td>
            </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"></tr>

          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

        </table>
        </div>
        <!-- Footer -->
        <!-- <div class="table-footer">
          <div class="table-info">
            Showing {{ startIndex }} – {{ endIndex }} of {{ paginator?.length || 0}} projects
          </div>

          <nav class="custom-pagination" aria-label="Pagination Navigation">
            <button class="page-btn" [disabled]="paginator?.pageIndex === 0" (click)="goToPreviousPage()">
              Previous
            </button>

            <button *ngFor="let page of pages" class="page-btn" [class.active]="page === (paginator?.pageIndex + 1)"
              [disabled]="typeof page === 'string'"
              (click)="typeof page === 'number' && goToPage(page)">
              {{ page }}
            </button>

            <button class="page-btn" [disabled]="paginator?.pageIndex >= (pageCount - 1)" (click)="goToNextPage()">
              Next
            </button>
            </nav>
            </div> -->

            <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" [length]="paginator?.length" showFirstLastButtons
              class="hidden-paginator">
            </mat-paginator>

            <div class="custom-paginator-wrapper">
              <div class="paginator-left">
                <span class="page-size-label">Showing {{ getStartIndex() }}–{{ getEndIndex() }} of {{ paginator?.length }} records</span>
              </div>

              <div class="paginator-center">
                <button class="page-nav-btn page-text-btn" [disabled]="paginator?.pageIndex === 0" (click)="paginator?.firstPage()" title="First page">
                  First
                </button>

                <button class="page-nav-btn" [disabled]="paginator?.pageIndex === 0" (click)="paginator?.previousPage()" title="Previous page">
                  <mat-icon>chevron_left</mat-icon>
                </button>

                <button *ngFor="let page of displayPageNumbers()" 
                  class="page-number-btn" 
                  [class.active]="paginator?.pageIndex === (page - 1)"
                  (click)="goToPage(page - 1)">
                  {{ page }}
                </button>

                <button class="page-nav-btn" [disabled]="paginator?.pageIndex >= (pageCount - 1)" (click)="paginator?.nextPage()" title="Next page">
                  <mat-icon>chevron_right</mat-icon>
                </button>

                <button class="page-nav-btn page-text-btn" [disabled]="paginator?.pageIndex >= (pageCount - 1)" (click)="paginator?.lastPage()" title="Last page">
                  Last
                </button>
              </div>

              <div class="paginator-right">
                <label class="page-size-label-text">Items per page:</label>
                <select class="page-size-select-custom" [value]="paginator?.pageSize" (change)="onPageSizeChange($event.target.value)">
                  <option [value]="5">5</option>
                  <option [value]="10">10</option>
                  <option [value]="20">20</option>
                </select>
              </div>
            </div>

      </div>

    </div>
  </mat-drawer-content>

  <!-- FILTER DRAWER -->
  <mat-drawer #filterDrawer position="end" mode="over" class="filter-drawer">

    <div class="filter-header">
      <h4>Filter Projects</h4>
      <button mat-icon-button (click)="filterDrawer.close()">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>

    <p class="filter-subtitle">
      Apply filters to refine your project list
    </p>

    <!-- Department Filter -->
    <h6>Department</h6>
    <mat-selection-list>
      <mat-list-option *ngFor="let dept of departments" [selected]="selectedDepartments.has(dept)"
        (click)="toggleDepartment(dept)">
        {{ dept }}
      </mat-list-option>
    </mat-selection-list>

    <!-- Status Filter -->
    <h6>Status</h6>
    <mat-selection-list>
      <mat-list-option *ngFor="let status of statuses" [selected]="selectedStatuses.has(status)"
        (click)="toggleStatus(status)">
        <span class="status-chip"
          [ngClass]="{ 'status-progress' : status === 'Submitted' || status === 'In Progress' || status === 'In progress' || status === 'in progress', 'status-pending': status === 'Pending Review', 'status-pending-rre-review': status === 'Pending RRE Review', 'status-pending-review': status === 'Pending RAES Review', 'status-completed': status === 'Completed', 'status-draft': status === 'Draft', 'status-overdue': status === 'Overdue' || status === 'OVERDUE' }">{{
          status }}</span>
      </mat-list-option>
    </mat-selection-list>

    <!-- Collection Filter -->
    <h6>Collection</h6>
    <mat-selection-list>
      <mat-list-option *ngFor="let col of collections" [selected]="selectedCollections.has(col)"
        (click)="toggleCollection(col)">
        {{ col }}
      </mat-list-option>
    </mat-selection-list>

    <div class="filter-actions mb-3">
      <button mat-flat-button class="button-clear-filters" (click)="clearFilters()">Clear</button>
      <button mat-flat-button class="button-apply-filters" (click)="applyFilters()">
        Apply
      </button>
    </div>

  </mat-drawer>

</mat-drawer-container>

<div class="confirm-overlay" *ngIf="showConfirmDialog">
  <div class="confirm-box">
    <div class="confirm-title">Confirm Action</div>
    <div class="confirm-content">
      <p class="confirm-text" *ngIf="confirmType === 'copy'">Do you want to copy details?</p>
      <p class="confirm-text" *ngIf="confirmType !== 'copy'">Are you sure you want to {{ confirmType === 'edit' ? 'edit' : 'delete' }} this project <strong class="confirm-project-name">{{ selectedProject?.project_name }}</strong>?</p>
    </div>
    <div class="d-flex gap-2 justify-content-end">
      <button type="button" class="btn btn-cancel" (click)="closeDialog()">Cancel</button>
      <button type="button" class="btn btn-danger" (click)="confirmYes()">{{ confirmType === 'edit' ? 'Edit Project' : (confirmType === 'copy' ? 'Copy' : 'Delete Project') }}</button>
    </div>
  </div>
</div>



<div
  class="activity-stream-overlay"
  *ngIf="showActivityStream"
  (click)="closeActivityStream()"
  (keydown.escape)="closeActivityStream()"
  tabindex="-1"
  aria-modal="true"
  role="dialog"
  aria-labelledby="activityStreamTitle"
>
  <div
    class="activity-stream-popup"
    (click)="$event.stopPropagation()"
    role="document"
  >
    <div class="header d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#cc0000" class="header-icon-svg">
          <path d="M360-160q-19 0-34-11t-22-28l-92-241H40v-80h228l92 244 184-485q7-17 22-28t34-11q19 0 34 11t22 28l92 241h172v80H692l-92-244-184 485q-7 17-22 28t-34 11Z" />
        </svg>
        <h6 class="m-0 activity-title" id="activityStreamTitle">Activity Stream</h6>
      </div>
      <button
        type="button"
        class="close-btn-plain"
        (click)="closeActivityStream()"
        aria-label="Close"
      >
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>

    <div class="activity-cards-container">
      <div *ngIf="isActivityLoading" class="activity-loading">
        <div class="spinner"></div>
        <span>Loading activity stream...</span>
      </div>
      <div *ngIf="!isActivityLoading && activityStreamData.length === 0" class="no-activity">
        <mat-icon>info_outline</mat-icon>
        <span>No activity found</span>
      </div>
      @for (activity of activityStreamData; track $index) {
        <div class="activity-card-row">
          <div class="activity-card">
            <div class="flex-grow-1">
              <div class="name">{{ activity.user_name || activity.created_by }}</div>

              <div class="review-text activity-description" *ngIf="activity.activity_description">{{ activity.activity_description }}</div>
              <div class="review-text user-comment" *ngIf="activity.user_comments">
                {{ activity.user_comments }}
              </div>

              <div class="time-row">
                <svg class="clock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <time [attr.datetime]="activity.created_at">
                  {{ activity.created_at | date:'MM/dd/yyyy hh:mm a' }}
                </time>
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="composer-wrap">
      <div class="d-flex align-items-flex-end gap-2 pe-3 ">
        <textarea
          id="newComment"
          class="comment-box form-control"
          [(ngModel)]="newComment"
          rows="1"
          placeholder="Add your review comment…"
          (keydown.enter)="($event.shiftKey ? null : postComment()); $event.preventDefault()"
        ></textarea>
        <button
          type="button"
          class="send-btn"
          [disabled]="!newComment || !newComment.trim()"
          (click)="postComment()"
          matTooltip="Send"
        >
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<app-tutorial-video-widget
  screenId="admin-dashboard-screen"
  title="Admin Dashboard walkthrough"
  teaserDescription="Watch a quick walkthrough of this screen."
  storageKey="admin-dashboard-screen-tutorial-seen"
  teaserPosition="bottom-right"
  launcherPosition="bottom-right"
  [autoPlaySequence]="adminDashboardTutorialSequence"
  [allowLauncherDismiss]="true">
</app-tutorial-video-widget>
